
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Yamunechya tiri" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Yamunechya tiri" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Yamunechya Tiri, Yamunechya Tiri Aarti, kanha aarti, Kanha Aarti in Marathi and English, Yamunechya Tiri Aarti in Marathi and English'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Kanha Aarti lyrics, Yamunechya Tiri Aarti, Shri Kanha Aarti, Yamunechya Tiri lyrics, Marathi Aarti lyrics, Kanha Aarti in Marathi and English, Devotional aarti, yamunechya tiri lyrics, यमुनेच्या तीरी'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/yamunechya-tiri.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/yamunechya-tiri.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Yamunechya tiri | Kanha Aarti - यमूनेच्या तीरी(कान्हा आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/yamunechya-tiri"
        },
        "headline": "Yamunechya tiri - यमूनेच्या तीरी(कान्हा आरती)",
        "name" : "Yamunechya tiri - Kanha Aarti",
        "description": "Explore the full lyrics of Aarti 'Yamunechya tiri' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/yamunechya-tiri.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  